import { appBaseUrl } from "@utils/BASE-URL";
import { trackEvent } from "@utils/analytics/event-analytics";
import { CONTACT_NUMBER, LANGUAGE, WEB_ENGAGE } from "@utils/constants";
import { CustomLink as Link } from "@utils/events/CustomLink";
import { formatter } from "@utils/metrics/countMetric";
import { addSubEventDetails } from "@utils/reduxToolkit/features/subEventSlice";
import { useRouter } from "next/router";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import styles from "../../../styles/pujaDetails.module.css";
import HeadingPuja from "../HeadingPuja";
import { Box, Divider, Typography, useMediaQuery } from "@mui/material";
import useCollapse from "react-collapsed";
import theme from "src/globalModule/styles/theme";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Image from "next/legacy/image";
import { deleteRegistrationDetails } from "@utils/reduxToolkit/features/registrationDetailsSlice";
import { deleteCart } from "@utils/reduxToolkit/features/cartSlice";
import { isCommunityAdmin } from "@utils/events/helpers";
import { Store } from "@utils/store/ContextStore";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const PujaCategoryListAB = ({
  data,
  uid,
  dummyRegistration
}) => {
  const {
    state
  } = useContext(Store);
  const user = state.user;
  const {
    t
  } = useTranslation();
  const router = useRouter();
  const dispatch = useDispatch();
  const [communityAdmin, setCommunityAdmin] = useState(false);
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  let sliderRef1 = useRef(null);
  let sliderRef2 = useRef(null);

  // console.log("sliderRef1", sliderRef1);
  // console.log("data", data);

  const smallScreen = useMediaQuery("(max-width:768px)");
  const [slideIndex, setSlideIndex] = useState(0);
  const [updateCount, setUpdateCount] = useState(0);
  var settings = {
    // customPaging: function(i) {
    //   return (
    //     <a>
    //       <div>ABAB</div>
    //     </a>
    //   );
    // },
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    swipeToSlide: true,
    focusOnSelect: true,
    afterChange: () => setUpdateCount(updateCount + 1),
    beforeChange: (current, next) => setSlideIndex(next)
  };
  var settingsIcons = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    // slidesToShow: 3,
    slidesToScroll: 1,
    adaptiveHeight: true,
    swipeToSlide: true
  };
  useEffect(() => {
    setCommunityAdmin(isCommunityAdmin(data?.viewerRole, data.uid, user.uid));
  }, [data?.viewerRole]);
  if (data?.CommunitySubEventsAllCategory?.length <= 0 || !data?.CommunitySubEventsAllCategory) {
    return null;
  }
  return <>
      {data?.CommunitySubEventsAllCategory?.map((category, index) => {
      const isCategoryPriceHigh = category?.CommunitySubEvents?.some(e => e.isPriceHigh);
      // console.log("basu", category);

      return <div key={index}>
            <HeadingPuja headline={category.name} />
            {smallScreen && category.position == 0 &&
        // category.categoryID == "043e5bdaccde49e8a9def733427d92ce" ? (
        <div className={styles.pujaIconsContainer}>
                <Slider {...settingsIcons} asNavFor={nav2} slidesToShow={category.CommunitySubEvents.length == 3 ? 3 : 4} ref={slider => sliderRef1 = slider}>
                  {category?.CommunitySubEvents?.map((e, idx) => {
              return <Box key={idx} padding={"0px 5px 5px 0px"} onClick={() => {
                trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS + " " + WEB_ENGAGE.ITEM_NAMES.SUB_KRIYA_SMALL_CARD + " " + WEB_ENGAGE.EVENT_NAMES.ITEM_CLICKED, {
                  [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS,
                  [WEB_ENGAGE.EVENT_PROPERTIES.ITEM_NAME]: WEB_ENGAGE.ITEM_NAMES.SUB_KRIYA_SMALL_CARD,
                  [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: data.name_WE,
                  [WEB_ENGAGE.EVENT_PROPERTIES.SUB_KRIYA_NAME]: e.name_WE,
                  [WEB_ENGAGE.EVENT_PROPERTIES.AMOUNT]: Number(e.eventRegistrationAmount),
                  [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_DEITY_TYPE]: data?.EventDeityTypes[0]?.DeityType.name,
                  [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: data.urlExtension
                });
                sliderRef2.slickGoTo(idx);
              }}>
                        <div className={`${styles.pujaIconDiv}  ${slideIndex === idx ? styles.activeIcon : null}`}>
                          <Image src={e.images[0]} alt={e.name + `utsav-puja`} width={"150"} height={"150"} style={{
                    objectFit: "cover"
                  }} placeholder="blur" blurDataURL={e.images[0]} loading={"lazy"} className={styles.pujaIconImage} />

                          {/* <div className={styles.pujaIconName}>{e.name}</div> */}
                          <div className={styles.pujaIconName}>
                            {e.shortName ? e.shortName : `${e.maxOfferingName} ${e.maxOfferingName === "1" ? t("Devotee") : t("Devotees")}`}
                          </div>
                          <div className={styles.pujaIconAmount}>
                            {formatter.format(e.eventRegistrationAmount).split(".")[0]}
                          </div>
                        </div>
                      </Box>;
            })}
                </Slider>
              </div>}
            {/* ) : (  <HeadingPuja headline={category.name} />
             )} */}
            {smallScreen && category.position == 0 ? <div className={styles.pujaItemsSlider}>
                <Slider {...settings} asNavFor={nav1} ref={slider => sliderRef2 = slider}>
                  {category?.CommunitySubEvents?.map((e, idx) => {
              return <Box key={idx} padding={"0 10px 10px 10px"}>
                        <PujaItem key={idx.toString()} eventID={data.urlExtension} deityType={data?.EventDeityTypes[0]?.DeityType.name} e={e} isAdmin={communityAdmin} name={e.name} name_WE={e.name_WE} templeName={data?.templeName} isPriceHighCategory={isCategoryPriceHigh}
                //userAddress={userAddress}
                uid={uid} eventName={data.name} eventName_WE={data.name_WE} deliveryAgent={data.deliveryAgent} categoryIndex={index} indexNumber={idx} maxOfferingName={e.maxOfferingName} categoryPosition={category.position} EventFestivalTimelines={data.EventFestivalTimelines} dummyRegistration={dummyRegistration} smallScreen={true} />
                      </Box>;
            })}
                </Slider>
              </div> : <Box className={category.position !== 0 ? styles.pujaItems : styles.pujaItemsRecommended}>
                {category?.CommunitySubEvents?.map((e, idx) => {
            return <PujaItem key={idx.toString()} eventID={data.urlExtension} deityType={data?.EventDeityTypes[0]?.DeityType.name} e={e} isAdmin={communityAdmin} name={e.name} name_WE={e.name_WE} templeName={data?.templeName} isPriceHighCategory={isCategoryPriceHigh} uid={uid} eventName={data.name} eventName_WE={data.name_WE} deliveryAgent={data.deliveryAgent} categoryIndex={index} indexNumber={idx} maxOfferingName={e.maxOfferingName} EventFestivalTimelines={data.EventFestivalTimelines} dummyRegistration={dummyRegistration} categoryPosition={category.position} smallScreen={false} />;
          })}
              </Box>}
          </div>;
    })}
    </>;
};
export default PujaCategoryListAB;
const PujaItem = ({
  categoryIndex,
  indexNumber,
  eventID,
  deityType,
  e,
  isAdmin,
  templeName,
  uid,
  eventName,
  eventName_WE,
  deliveryAgent,
  maxOfferingName,
  categoryPosition,
  EventFestivalTimelines,
  dummyRegistration,
  smallScreen
}) => {
  // console.log("key", indexNumber, EventFestivalTimelines);
  const dispatch = useDispatch();
  const router = useRouter();
  const {
    t
  } = useTranslation();
  const [showMoreBtn, setShowMoreBtn] = useState(false);
  const [seeMore, setSeeMore] = useState(false);
  const {
    getCollapseProps,
    getToggleProps
  } = useCollapse({
    collapsedHeight: 110
  });
  const bigScreen = useMediaQuery("(min-width:768px)");
  const bookBtnRef = useRef(null);

  // console.log("bookBtnRef", bookBtnRef);

  useEffect(() => {
    if (e.description) {
      if (bigScreen ? e.description.length > 1000 : e.description.length > 100) {
        setShowMoreBtn(true);
      }
    }
  }, [e.description]);
  let shareMessage;
  shareMessage = `Namaste🙏,\nI want to register for ${e.name} at ${templeName}.\n${appBaseUrl}/${router.locale}/puja/${deityType}/${eventID}\nPlease send me details for registration in this puja.`;
  if (uid !== "guest") shareMessage += ` Here is my profile details\n${appBaseUrl}/${router.locale}/profile/${uid}`;
  const whatsappUrl = encodeURI(`https://api.whatsapp.com/send?phone=91${CONTACT_NUMBER.number}&text=${shareMessage}`);
  const redirectToRegistration = () => {
    if (EventFestivalTimelines.length > 0) {
      trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS + " " + WEB_ENGAGE.BUTTON_NAMES.SUB_KRIYA_BOOK + " " + WEB_ENGAGE.EVENT_NAMES.BUTTON_CLICKED, {
        [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS,
        [WEB_ENGAGE.EVENT_PROPERTIES.BUTTON_NAME]: WEB_ENGAGE.BUTTON_NAMES.SUB_KRIYA_BOOK,
        [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: eventName_WE,
        [WEB_ENGAGE.EVENT_PROPERTIES.SUB_KRIYA_NAME]: e.name_WE,
        [WEB_ENGAGE.EVENT_PROPERTIES.AMOUNT]: Number(e.eventRegistrationAmount),
        [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_DEITY_TYPE]: deityType,
        [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: eventID
      });
      const subEventObj = {
        ...e,
        templeName: templeName,
        eventName: eventName,
        eventName_WE: eventName_WE,
        referrerID: null,
        contact: null,
        notes: null,
        language: router.locale,
        deliveryAgent: deliveryAgent,
        deityName: deityType,
        festivalName: EventFestivalTimelines.length > 0 ? EventFestivalTimelines[0].FestivalTimeline.title : null
      };
      dispatch(addSubEventDetails(subEventObj));
      dispatch(deleteRegistrationDetails());
      dispatch(deleteCart());
      // sessionStorage.removeItem("previousRoute");
      // router.push(`/puja/${deityType}/${eventID}/${e.urlExtension}`, undefined, {
      //   locale: router.locale,
      // });
      if (bigScreen) {
        router.push(`/puja/registration/${eventID}/${e.urlExtension}`, undefined, {
          locale: router.locale
        });
        return;
      }
      dummyRegistration(subEventObj);
    }
  };
  return <div className={styles.pujaCardContainer} data-sentry-component="PujaItem" data-sentry-source-file="PujaCategoryList.jsx">
      {categoryPosition != 0 ? <div className={styles.pOfferImgBx} onClick={redirectToRegistration}>
          {!e.images?.length <= 0 ? <Image src={e.images[0]} alt={e.name + `${t("utsav-kriya-image")}`}
      // width={"100vw"}
      // height={"100%"}
      layout="fill" objectFit="cover" placeholder="blur" blurDataURL={e.images[0]} loading={"lazy"} /> : null}
        </div> : <div className={styles.pOfferImgRecommended} onClick={redirectToRegistration}>
          {!e.images?.length <= 0 && <Image src={e.images[0]} alt={e.name + `${t("utsav-kriya-image")}`}
      // width={"100vw"}
      // height={"100%"}
      layout="fill" objectFit="cover" placeholder="blur" blurDataURL={e.images[0]} loading={"lazy"} />}
        </div>}
      <div className={categoryPosition === 0 ? styles.pOfferBxWithoutBorder : styles.pOfferBx}>
        <Typography className={styles.pOfferName} data-sentry-element="Typography" data-sentry-source-file="PujaCategoryList.jsx">{e.name}</Typography>
        <div style={{
        display: "flex",
        marginBottom: "10px"
      }}>
          <Divider orientation="vertical" flexItem className={styles.devoteeNumberDivider} data-sentry-element="Divider" data-sentry-source-file="PujaCategoryList.jsx" />
          <Typography fontSize={"15px"} data-sentry-element="Typography" data-sentry-source-file="PujaCategoryList.jsx">
            {router.locale === LANGUAGE.ENGLISH && t("upto")} {maxOfferingName}{" "}
            {Number(maxOfferingName) <= 1 ? t("Devotee") : t("Devotees")}
          </Typography>
        </div>

        <div className={`${styles.eDesc} ${styles.mobileeDesc}`}>
          {showMoreBtn ? <>
              <div {...getCollapseProps()}>{e.description}</div>
              <button className={styles.seeMoreBtn} {...getToggleProps({
            onClick: () => {
              setSeeMore(cur => !cur);
            }
          })}>
                <Typography fontSize={"15px"} sx={{
              color: theme.palette.text.secondaryDark,
              fontWeight: 600
            }}>
                  {!seeMore ? t("show-more") : t("show-less-0")}
                </Typography>
                {!seeMore ? <ExpandMoreIcon /> : <ExpandLessIcon />}
              </button>
            </> : <>{e.description}</>}
        </div>

        {e.isPriceHigh ? <div className={styles.btnBx}>
            {" "}
            <Link href={whatsappUrl} target="_blank" rel="noopener noreferrer alternate" hrefLang={router.locale}>
              <button className={styles.pOfferButton}>
                {" "}
                {t("contact-us")}{" "}
              </button>
            </Link>
          </div> : <div
      // href={`/puja/registration/${eventID}/${e.urlExtension}`}
      // passHref
      // rel="alternate"
      // hrefLang={router.locale}
      onClick={() => {
        // console.log("Button Clicked");
        if (EventFestivalTimelines.length > 0) {
          trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS + " " + WEB_ENGAGE.BUTTON_NAMES.SUB_KRIYA_BOOK + " " + WEB_ENGAGE.EVENT_NAMES.BUTTON_CLICKED, {
            [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS,
            [WEB_ENGAGE.EVENT_PROPERTIES.BUTTON_NAME]: WEB_ENGAGE.BUTTON_NAMES.SUB_KRIYA_BOOK,
            [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: eventName_WE,
            [WEB_ENGAGE.EVENT_PROPERTIES.SUB_KRIYA_NAME]: e.name_WE,
            [WEB_ENGAGE.EVENT_PROPERTIES.AMOUNT]: Number(e.eventRegistrationAmount),
            [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_DEITY_TYPE]: deityType,
            [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: eventID
          });
          const subEventObj = {
            ...e,
            templeName: templeName,
            eventName: eventName,
            eventName_WE: eventName_WE,
            referrerID: null,
            contact: null,
            notes: null,
            language: router.locale,
            deliveryAgent: deliveryAgent,
            deityName: deityType,
            festivalName: EventFestivalTimelines.length > 0 ? EventFestivalTimelines[0].FestivalTimeline.title : null
          };
          dispatch(addSubEventDetails(subEventObj));
          dispatch(deleteRegistrationDetails());
          dispatch(deleteCart());
          // sessionStorage.removeItem("previousRoute");

          if (bigScreen) {
            router.push(`/puja/registration/${eventID}/${e.urlExtension}`, undefined, {
              locale: router.locale
            });
            return;
          }
          dummyRegistration(subEventObj);
        }
      }}>
            {/* <div className={styles.btnBx}> */}
            {e?.eventRegistrationAmount ? <button className={`${EventFestivalTimelines.length === 0 ? styles.pOfferButton_admin : styles.pOfferButton}`} disabled={EventFestivalTimelines.length === 0}
        // disabled={true}
        ref={bookBtnRef}>
                {/* {`${t("book-for")} ${
                 formatter.format(e.eventRegistrationAmount).split(".")[0]
                 }/-`} */}
                {`${t("book-for")} ₹ ${e.eventRegistrationAmount}/-`}
              </button> : <button className={styles.pOfferButton}>{t("register")}</button>}
            {/* </div> */}
          </div>}
      </div>
    </div>;
};